export default function AlertItem({alert, className}) {
    const iconMap = {
        "caution": {
            icon: "hand",
            color: "text-coral-100"
        },
        "information": {
            icon: "circle-exclamation",
            color: "text-green-100"
        },
        "danger": {
            icon: "triangle-exclamation",
            color: "text-coral-100"
        },
        "park closure": {
            icon: "circle-minus",
            color: "text-coral-100"
        }
    }
    return(
        <div key={alert.id} className={className}>
            <div className={`flex items-center pb-2`}>
                {alert.category ?
                    <i className={`fa-solid fa-${iconMap[alert.category.toLowerCase()].icon} ${iconMap[alert.category.toLowerCase()].color}`}></i>
                : null}
                <p className={`font-brandon font-black uppercase text-xs pl-2 ${iconMap[alert.category.toLowerCase()].color}`}>
                    {alert.category} - {alert.title}
                </p>
            </div>
            <p className={`text-xs`}>
                {alert.description} {alert.url ? <a href={alert.url} target="_blank" rel="noreferrer" className={`underline`}>Read more.</a> : null}
            </p>
        </div>
    )
}